import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isDecaShipperTaxIdBlocked } from '@okcargo-apps/shared-domain';
import { DecaCompanyFormModel, DecaDocumentFormModel, DecaSegmentFormModel } from './deca-forms.model';

const CARRIER_REQUIRED_FIELDS = ['companyName', 'taxId', 'street', 'contactFirstName', 'contactLastName'] as const;

export const decaBlockedShipperTaxIdValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const taxId = control.value as string | null;

  if (!taxId?.trim()) {
    return null;
  }

  return isDecaShipperTaxIdBlocked(taxId) ? { blockedShipperTaxId: true } : null;
};

export const specialAuthorizationTypeRequiredValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const group = control.parent as FormGroup<DecaDocumentFormModel> | null;
  const hasAuth = group?.controls.hasSpecialAuthorization?.value;

  if (hasAuth && !control.value) {
    return { required: true };
  }

  return null;
};

export const carrierDataValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const group = control as FormGroup<DecaCompanyFormModel>;
  const email = group.controls.contactEmail?.value?.trim();

  if (!email) return null;

  const isMissing = CARRIER_REQUIRED_FIELDS.some((ctrlName) => !group.controls[ctrlName].value?.trim());

  return isMissing ? { missingCarrierData: true } : null;
};

export function chronologicalSegmentDateValidator(
  getSegmentsArray: () => FormArray<FormGroup<DecaSegmentFormModel>> | undefined,
  getSegmentGroup: () => FormGroup<DecaSegmentFormModel> | undefined,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const originVal = control.value;
    const segmentsArray = getSegmentsArray();
    const segGroup = getSegmentGroup();
    if (!segmentsArray || !originVal || !segGroup) return null;

    const currentIndex = segmentsArray.controls.indexOf(segGroup);
    if (currentIndex <= 0) return null;

    const prevGroup = segmentsArray.at(currentIndex - 1);
    const destVal = prevGroup?.controls.destination.controls.date.value ?? null;

    if (destVal) {
      const originTime = new Date(originVal).getTime();
      const destTime = new Date(destVal).getTime();
      if (!isNaN(originTime) && !isNaN(destTime) && originTime < destTime) {
        return {
          chronologicallyBeforePreviousSegment: {
            message: 'Error. No puede seleccionar una fecha y hora anterior a la finalización del tramo anterior',
          },
        };
      }
    }
    return null;
  };
}
